<template>
  <layout>
    <div slot="content">
      <i-card title="运营豆">
        <template slot="right-menu">
          <div style="display: flex;justify-content: end;align-items: center">
            <span style="font-size: 12px;margin-right: 5px">剩余</span>
            <h1 style="margin-right: 10px;display: inline-block">{{ balance }}</h1>
            <el-link type="success" @click="showRecharge" style="margin-right: 10px" v-if="isSuperAdmin">立即充值</el-link>
            <el-link type="primary" @click="getBalance(true)">刷新余额</el-link>
          </div>

        </template>
        <div slot="content">
          <el-form :inline="true" size="small" style="text-align: right">
            <el-form-item label="订单号">
              <el-input placeholder="请输入订单号"  clearable v-model="filter.uuid" ></el-input>
            </el-form-item>
            <el-form-item label="订单日期">
              <el-date-picker start-placeholder="开始日期" end-placeholder="结束日期"
                              v-model="filter.date_range" value-format="yyyy-MM-dd" type="daterange"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(false)">查找</el-button>
              <el-button type="primary" @click="exportData()">导出</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table :border="true" :highlight-current-row="true" :data="pageList" v-loading="loading">
            <el-table-column prop="order_uuid"  label="订单号"></el-table-column>
            <el-table-column prop="order_title"  label="物品名称"></el-table-column>
            <el-table-column prop="remark"  label="使用明细"></el-table-column>
            <el-table-column prop="goods_count"  label="物品数量" width="100"></el-table-column>
            <el-table-column prop="total"  label="运营豆数量" width="100"></el-table-column>
            <el-table-column prop="curr_balance"  label="当前余额" width="100"></el-table-column>
            <el-table-column prop="type"  label="类型">
              <template slot-scope="scope">
                <el-tag type="success" v-if="parseInt(scope.row.type) === 1">增加</el-tag>
                <el-tag type="danger" v-if="parseInt(scope.row.type) === 2">扣除</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at"  label="日期"></el-table-column>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :page-size="pageInfo.per_page" :current-page="pageInfo.current_page"
                           layout="prev, pager, next" @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <el-dialog title="充值运营豆" :visible.sync="showModal" width="40%">
        <el-form ref="form"  label-width="100px">
          <el-form-item label="充值金额" required>
            <el-input v-model="rechargeTotal" placeholder="请输入充值金额" filterable style="width: 80%">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="doRecharge" :loading="rechargeLoading">确 认</el-button>
          <el-button @click="showModal = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "sailings",
  data: function () {
    return {
      pageUrl: "opWalletDetails",
      loading: false,
      pageList: [],
      pageInfo: {
        per_page: 20,
        current_page: 1,
        total: 0,
      },
      filter:{
        uuid:'',
        date_range:''
      },
      balance: 0.00,
      showModal: false,
      rechargeTotal: '',
      rechargeLoading:false,
      isSuperAdmin:false,
    }
  },
  methods: {

    getList: function (isExport) {
      this.loading = true;
      this.$http.request(this.pageUrl, {filter: this.filter,page:this.pageInfo.page,is_export: isExport ? 1:0}).then(res => {
        if(!isExport){
          this.loading = false;
          window.scroll(0,0)
          this.pageList = res.data;
          this.pageInfo = res.meta;
          this.getBalance();
        }else{
          this.loading = false;
        }
      });
    },
    exportData: function () {
      const url = this.$http.request(this.pageUrl, {
        filter: this.filter,
        is_export: 1
      }, true);
      window.open(url)
    },
    reset:function (){
      window.location.reload();
    },
    getIsSuperAdmin: function () {
      this.$http.request('isSuperAdmin').then(res => {
      this.isSuperAdmin = res.data.is_super_admin;
      });
    },
    changePage: function (page) {
      this.pageInfo.page = page;
      this.getList(false);
    },
    getBalance:function (showToast){
      this.$http.request("opWalletBalance").then(res => {
        if(showToast){
          this.$message({ message: '已刷新', type: 'success'});
        }
        this.balance = res.data.balance;
      });
    },
    showRecharge:function (){
      this.showModal = true;
      this.rechargeTotal = '';
    },
    doRecharge:function (){
      this.rechargeLoading = true;
      this.$http.request('opWalletRecharge',{total: this.rechargeTotal}).then(res=>{
        this.rechargeLoading = false;
        if (res.status === 'success') {
          this.showModal = false;
          this.getList(false);
          this.$message({
            message: res.message, type: 'success'
          });
        }
      });
    }
  },
  created: function () {
    this.getList();
    this.getBalance();
    this.getIsSuperAdmin();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/op_wallet/op_wallet.vue